import axios from "axios";
import { getErrToast, trimmedObject } from "./helpers";

export default function AxiosInstance() {
  const token = localStorage.getItem("userdatatoken") || null;

  const instance = axios.create({
    baseURL: import.meta.env.VITE_API_URL || "https://dev.api.anthro.care/api",
    timeout: 60000,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // default
    },
  });

  instance.interceptors.request.use((config: any) => {
    let newConfig = { ...config };

    // ✅ FIX: Let browser set boundary. Do NOT set Content-Type manually.
    if (newConfig?.isFormData) {
      if (newConfig.headers) {
        delete newConfig.headers["Content-Type"];
      }
    }

    // Keep your original orgId logic
    if (newConfig?.params?.orgId && newConfig?.params?.orgId == "anthro-care") {
      newConfig = { ...newConfig, params: { ...newConfig.params, orgId: "" } };
    }

    // Keep your original trimming logic
    if (newConfig?.data && typeof newConfig?.data == "string") {
      let parsedObj = {};
      let isParsed = false;
      try {
        parsedObj = JSON.parse(newConfig?.data);
        isParsed = true;
      } catch (error) {
        console.log("err in parsing");
      }
      newConfig = {
        ...newConfig,
        data: isParsed
          ? JSON.stringify(trimmedObject(parsedObj))
          : newConfig?.data,
      };
    }
    // ❗ FIX: Do NOT trim FormData
    else if (
      newConfig?.data &&
      typeof newConfig?.data == "object" &&
      !(newConfig.data instanceof FormData)
    ) {
      newConfig = { ...newConfig, data: trimmedObject(newConfig?.data) };
    }

    return newConfig;
  });

  instance.interceptors.response.use(
    (values) => values,
    (error) => {
      if (error.response?.status == 401) {
        // Preserve Anthro AI IdToken so `/ai-chat` can keep working even
        // when the portal session expires and triggers a 401.
        const anthroAiIdToken = localStorage.getItem("anthroAiIdToken");
        localStorage.clear();
        if (anthroAiIdToken) {
          localStorage.setItem("anthroAiIdToken", anthroAiIdToken);
        }

        if (!window.location.pathname.includes("auth")) {
          setTimeout(() => {
            window.location.pathname = "/auth";
          }, 1500);
        }

        getErrToast(error);
      }

      return Promise.reject(error);
    },
  );

  return instance;
}
